<template>
  <el-tabs v-model="activeName" class="tabs">
    <el-tab-pane name="first" label="电脑端" class="mineCon">
      <div class="help">
        <p><strong>【初次聊天】</strong></p>
        <p><strong>第一步：</strong>登录状态下，在顶部菜单中点击<span class="orange">【专业医生】</span>或<span class="orange">【我要咨询】</span>
        </p>
        <img src="../../../assets/userImg/chat_e.png" alt="" height="264">
        <p><strong>第二步：</strong>在【专业医生】或【我要咨询】页面列表中，点击需要私聊医生的<span class="orange">【私信】</span>按钮，进入聊天页面

        </p>
        <img src="../../../assets/userImg/chat_f.png" alt="" height="472">
        <p><strong>【当前账号有关注医师】</strong></p>
        <p><strong></strong>登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【私信消息】</span></p>
        <img src="../../../assets/userImg/chat_a.png" alt="">
        <p><strong>【最后一步】：</strong>在【私信消息】页面中，可与医生进行线上文字交流</p>
        <p>
          ① 会话列表: 点击对应会话切换聊天会话<br/>
          ② 聊天内容: 鼠标右键消息,复制此条消息内容至剪切板<br/>
          ③ 聊天记录: 点击加载更多聊天记录<br/>
          ④ 编辑发送内容:该区域为编辑待发送信息区域<br/>
          ⑤ 发送信息: 将编辑区内容发送给对方
        </p>
        <img src="../../../assets/userImg/chat_b.png" alt="">
        <p><strong>【私信领取优惠券】</strong></p>
        <p><strong>第一步：</strong>在【私信消息】页面中，找到医生，点击医生发送的优惠券链接，进入【优惠券领取】网页</p>
        <img src="../../../assets/userImg/chat_c.png" alt="">
        <p><strong>第二步：</strong>在【领取优惠券】网页中，点击【领取】按钮，即领取成功，保存至【我的优惠券】中，在优惠券有效期内用于咨询预约</p>
        <img src="../../../assets/userImg/chat_d.png" alt="">
      </div>
    </el-tab-pane>
    <!--    <el-tab-pane name="second" label="移动端" class="mineCon">
          <div class="help">
            22
          </div>
        </el-tab-pane>-->
  </el-tabs>


</template>

<script>
export default {
  name: "chat",
  data() {
    return {activeName: 'first'}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
